import styled from 'styled-components';
import { BasketPaymentDetailsStyled } from '../BasketPaymentDetailsStyled';
import { rem } from 'polished';

export const BasketPaymentDetailsOV = styled(BasketPaymentDetailsStyled)`
    .financeSummary {
        background: ${({ theme }) => theme.colors.grey10};

        .infoIcon {
            svg {
                g {
                    circle {
                        fill: ${({ theme }) => theme.colors.black};
                        stroke: none;
                    }
                    path {
                        fill: ${({ theme }) => theme.colors.pureWhite};
                    }
                }

                path {
                    fill: unset;
                }
            }
        }

        .monthlyPaymentDesktop {
            font-size: ${rem(20)};
        }

        .monthlyPaymentMobile,
        .monthlyPaymentDetailMobile {
            .price {
                font-size: ${rem(20)};
            }
        }

        .personalizeButton {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
        }
    }

    .needHand {
        background: ${({ theme }) => theme.colors.grey10};
        border-radius: 0;

        &_label {
            font-size: ${rem(16)};
            color: ${({ theme }) => theme.colors.black2};
        }

        &_modalButton {
            font-size: ${rem(16)};
            color: ${({ theme }) => theme.colors.black2};
            border-bottom: 1px solid transparent;
            padding: 0;

            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black2};
                }
            }

            &:hover,
            &:focus-visible {
                border-bottom: 1px solid ${({ theme }) => theme.colors.black2};
            }
        }

        &_phone {
            font-size: ${rem(16)};
            color: ${({ theme }) => theme.colors.black2};
            border-bottom: 1px solid transparent;

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.black2};
                border-bottom: 1px solid ${({ theme }) => theme.colors.black2};
            }
        }
    }

    .legalText {
        p {
            font-size: ${({ theme }) => theme.fontSizes.h6};
            color: ${({ theme }) => theme.colors.grey28};
        }
    }
`;
